import {useQuery} from '@tanstack/react-query'
import {api} from '@/lib/api'
import type {components} from '@/lib/api-schema'

export type Dashboard = components['schemas']['DashboardRead']

/** Todo agregado en el servidor contra la fecha de Bogotá: nada se recalcula en el navegador
 * sobre listas paginadas. */
export function useDashboard(businessId: string | undefined, year?: number) {
  return useQuery({
    queryKey: ['dashboard', businessId, year ?? 'current'],
    queryFn: async () =>
      (
        await api.get<Dashboard>(`/businesses/${businessId}/sgsst/dashboard`, {
          params: year ? {year} : {},
        })
      ).data,
    enabled: !!businessId,
  })
}
